import React, { Component } from "react";
import { connect } from 'react-redux';
import { Menu } from "antd";

const SubMenu = Menu.SubMenu;

class SideNav extends Component {
    constructor(props) {
        super(props);
        const { selectKey } = props;
        this.state = {
            current: selectKey,
        };
    }

    handleClick = e => {
        this.setState({ current: e.key });
    }

    render () {
        const { current } = this.state;
        const { menuAuth } = this.props;
        const { TEACH_LEADER, additionalMenuList } = menuAuth;
        const { curRole, curEmployeeCode } = sessionStorage;
        const isCRC = curRole === 'CRC';
        const showTeachingDirector = isCRC ? (TEACH_LEADER || []).some(i => i == curEmployeeCode) : true;
        const showAdditionalTeaching = (additionalMenuList || []).some(el => el.menuKey == 'TRAINING_MANAGEMENT_LIST');
        return (
            <aside className="sidebar">
                <Menu
                    onClick={this.handleClick}
                    defaultOpenKeys={['sub1']}
                    selectedKeys={[current]}
                    mode="inline"
                >
                    {
                        showAdditionalTeaching ? 
                        <SubMenu key="sub1" title={<span><i className="icon iconfont">&#xe8fe;</i><span>带教管理</span></span>}>
                            <Menu.Item key="management">
                                <a href="#/teaching/management">带教管理</a>
                            </Menu.Item>
                        </SubMenu>
                        :
                        <SubMenu key="sub1" title={<span><i className="icon iconfont">&#xe8fe;</i><span>带教管理</span></span>}>
                        {
                            showTeachingDirector &&
                            <Menu.Item key="director">
                                <a href="#/teaching/director">带教负责人</a>
                            </Menu.Item>
                        }
                        {
                            showTeachingDirector && 
                            <Menu.Item key="management">
                                <a href="#/teaching/management">带教管理</a>
                            </Menu.Item>
                        }
                        {
                            isCRC &&
                            <Menu.Item key="qualityAssessmentSheet">
                                <a href="#/teaching/qualityAssessmentSheet">带教质量评估表</a>
                            </Menu.Item>
                        }
                    </SubMenu>
                    }
                </Menu>
            </aside>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        menuAuth: state.menuState.menuAuth || {},
    }
}

export default connect(mapStateToProps, null)(SideNav);


// WEBPACK FOOTER //
// ./src/components/teachingManagement/SideNav.js